import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Loading from "../../Loading/Loading";
import Message from "../../Modal/Message";
import DownloadIcon from "@mui/icons-material/Download";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import adminAlternative from "../../Assets/adminAlternative.png";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CommuteOutlinedIcon from "@mui/icons-material/CommuteOutlined";
import SwapHorizOutlinedIcon from "@mui/icons-material/SwapHorizOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
} from "@mui/material";
import useHttp from "../../Hooks/use-http";
import TransferStaff from "./TransferStaff";
import { toast } from "react-toastify";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";

const COLUMN_WIDTHS = {
  Name: "14%",
  Department: "6%",
  "Pickup Address (Route)": "30%",
  "Drop Address (Route)": "30%",
  Status: "5%",
  "QR Code": "12%",
  Actions: "3%",
};

const Records = ({
  isLoading,
  data,
  headers,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const [isStudentDisbaleClicked, setIsStudentDisableClicked] = useState(false);
  const [isStaffDisbleClicked, setIsStaffDisableClicked] = useState(false);
  const [isStaffTransferClicked, setIsStaffTransferClicked] = useState(false);
  const [isResponse, setIsResponse] = useState();
  const history = useHistory();
  const [orderBy, setOrderBy] = useState("Name");
  const [order, setOrder] = useState("asc");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // Staff details for actions
  const [staffDetails, setStaffDetails] = useState({
    name: "",
    mobile_no: "",
    departmentName: "",
    corporateId: "",
    parentID: "",
  });

  const handleMenuClick = (event, row) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleSort = (column, event) => {
    event.stopPropagation();
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };

  const sortedData = React.useMemo(() => {
    return [...data].sort((a, b) => {
      if (order === "asc") {
        return a[orderBy] > b[orderBy] ? 1 : -1;
      } else {
        return a[orderBy] < b[orderBy] ? 1 : -1;
      }
    });
  }, [data, order, orderBy]);

  const paginatedData = React.useMemo(() => {
    return sortedData.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [sortedData, page, rowsPerPage]);

  const { sendRequest } = useHttp();

  const authenticateUser = (data) => {
    if (data.status == "201" || data.status == "200") {
      toast.success(`${staffDetails.name} has been successfully disabled`);
    } else {
      toast.error(
        data.message ? data.message : "Something went wrong, please try again"
      );
    }
    setIsStudentDisableClicked(false);
    setIsStaffDisableClicked(false);
  };

  useEffect(() => {
    if (isStaffDisbleClicked) {
      sendRequest(
        {
          url: "/suspendrider",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            mobileNumber: staffDetails.mobile_no,
          },
        },
        authenticateUser
      );
    }
  }, [isStaffDisbleClicked, sendRequest]);

  const handleActionClick = (action, row) => {
    setStaffDetails({
      name: row?.name,
      mobile_no: row?.mobile_no,
      departmentName: row?.departmentName,
      corporateId: row?.corporateId,
      parentID: row?.parentID,
    });

    switch (action) {
      case "disable":
        setIsStudentDisableClicked(true);
        break;
      case "transfer":
        setIsStaffTransferClicked(true);
        break;
      case "trips":
        history.push(`/trips?staff=${row?.mobile_no}`);
        break;
      case "edit":
        history.push(
          `student-staff-registration/?name=${row?.corporateName}&corpId=${
            row?.parentID || row?.corporateID
          }&edit=${row?.mobile_no}`
        );
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        // height: "calc(100vh - 200px)",
      }}
    >
      <Paper
        sx={{
          width: "100%",
          mb: 2,
          borderRadius: "10px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          // overflow: "hidden",
        }}
      >
        <TableContainer component={Paper} sx={{ maxWidth: "100%", flex: 1 }}>
          <Table sx={{ maxWidth: "100%" }} stickyHeader>
            <TableHead>
              <TableRow>
                {headers?.map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      py: 0,
                      px: 3,
                      fontWeight: "bold",
                      color: "rgba(0, 0, 0, 0.87)",
                      width: COLUMN_WIDTHS[header] || "auto",
                      backgroundColor: "#E1E2E2", // Light gray background
                      borderBottom: "1px solid #e0e0e0",
                    }}
                  >
                    <TableSortLabel
                      active={orderBy === header}
                      direction={orderBy === header ? order : "asc"}
                      onClick={(event) => handleSort(header, event)}
                      sx={{ fontSize: "0.8rem", color: "rgba(0, 0, 0, 0.87)" }}
                    >
                      {header}
                    </TableSortLabel>
                  </TableCell>
                ))}
                <TableCell
                  sx={{
                    py: 0,
                    px: 4,
                    fontWeight: "bold",
                    color: "rgba(0, 0, 0, 0.87)",
                    width: COLUMN_WIDTHS["Actions"],
                    backgroundColor: "#E1E2E2",
                  }}
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={headers?.length + 1}>
                    <Loading datatable="true" />
                  </TableCell>
                </TableRow>
              ) : paginatedData?.length > 0 ? (
                paginatedData?.map((row) => (
                  <TableRow key={`${row.id}-${row.mobile_no}`} hover>
                    <TableCell
                      sx={{ fontFamily: "Montserrat" }}
                      scope="row"
                      padding="none"
                      align="center"
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={row.RiderImage || adminAlternative}
                          style={{
                            borderRadius: "50%",
                            objectFit: "cover",
                            width: "45px",
                            height: "45px",
                            marginRight: "4px",
                          }}
                          alt="Staff"
                        />
                        <div>
                          <p>{row?.name}</p>
                          <p style={{ fontSize: "75%", color: "gray" }}>
                            {row?.mobile_no}
                          </p>
                        </div>
                      </div>
                    </TableCell>

                    {localStorage.getItem("roleId") == "1" && (
                      <TableCell sx={{ fontSize: "0.8rem", p: 0, px: 3 }}>
                        {row.corporateName}
                      </TableCell>
                    )}

                    <TableCell sx={{ fontSize: "0.8rem", p: 0, px: 3 }}>
                      {row.departmentName}
                    </TableCell>

                    <TableCell sx={{ fontSize: "0.8rem", py: 1, px: 3 }}>
                      {row.pickupAddress ? (
                        <>
                          <a
                            href={`https://www.google.com/maps?q=${row?.pickupLL}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "blue",
                            }}
                          >
                            {row.pickupAddress}
                          </a>
                          <br />(
                          <span style={{ color: "gray" }}>
                            {row.pickupRouteName || "Not Assigned"}
                          </span>
                          )
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell sx={{ fontSize: "0.8rem", py: 1, px: 3 }}>
                      {row.dropAddress ? (
                        <>
                          <a
                            href={`https://www.google.com/maps?q=${row?.dropLL}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "blue",
                            }}
                          >
                            {row.dropAddress}
                          </a>
                          <br />(
                          <span style={{ color: "gray" }}>
                            {row.dropRouteName || "Not Assigned"}
                          </span>
                          )
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell sx={{ fontSize: "0.8rem", p: 0, px: 3 }}>
                      <div
                        style={{
                          color: !row?.status ? "#44B150" : "#D83434",
                          border: `1px solid ${
                            !row?.status ? "#44B150" : "#D83434"
                          }`,
                          borderRadius: "10px",
                          padding: "2px",
                          textAlign: "center",
                          textTransform: "capitalize",
                          margin: "auto",
                        }}
                      >
                        {!row?.status ? "Active" : "Suspended"}
                      </div>
                    </TableCell>

                    <TableCell
                      sx={{ fontFamily: "Montserrat" }}
                      align="center"
                      onClick={() =>
                        window.open(
                          `${window.location.origin}/rider/${row.mobile_no}`
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <div style={{ display: "flex", gap: "5px" }}>
                        <DownloadIcon />
                        {`(${row.uniqueNumber})`}
                      </div>
                    </TableCell>

                    {localStorage.getItem("userType") !== "AccountManager" && (
                      <TableCell>
                        <IconButton
                          onClick={(event) => handleMenuClick(event, row)}
                        >
                          <MoreVertIcon />
                        </IconButton>

                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && selectedRow?.id === row.id}
                          onClose={handleMenuClose}
                          sx={{
                            "& .MuiPaper-root": {
                              boxShadow: "none",
                              borderRadius: "10px",
                              border: "1px solid #ccc",
                            },
                          }}
                        >
                          <MenuItem
                            onClick={(e) => {
                              e.stopPropagation();
                              handleActionClick("edit", row);
                            }}
                          >
                            <ListItemIcon>
                              <EditOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Edit Details</ListItemText>
                          </MenuItem>

                          <MenuItem
                            onClick={(e) => handleActionClick("trips", row)}
                          >
                            <ListItemIcon>
                              <CommuteOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>View Trips</ListItemText>
                          </MenuItem>

                          <MenuItem
                            onClick={(e) => handleActionClick("transfer", row)}
                          >
                            <ListItemIcon>
                              <SwapHorizOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Transfer Department</ListItemText>
                          </MenuItem>

                          <MenuItem
                            onClick={(e) => handleActionClick("disable", row)}
                          >
                            <ListItemIcon>
                              <BlockOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Disable Staff</ListItemText>
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={headers?.length + 1} align="center">
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Modals and Dialogs */}
        {isStudentDisbaleClicked && (
          <div className="background">
            <div className="alert_studentDisble">
              <header>
                <span>Alert</span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsStudentDisableClicked(false)}
                >
                  ×
                </span>
              </header>
              <hr />
              <main>
                <p>You are going to disable the staff {staffDetails.name}</p>
              </main>
              <footer>
                <span>Do you want to proceed?</span>
                <div>
                  <button onClick={() => setIsStaffDisableClicked(true)}>
                    Yes
                  </button>
                  <button onClick={() => setIsStudentDisableClicked(false)}>
                    No
                  </button>
                </div>
              </footer>
            </div>
          </div>
        )}

        {isStaffTransferClicked && (
          <TransferStaff
            setIsResponse={setIsResponse}
            dptName={staffDetails.departmentName}
            staffName={staffDetails.name}
            staffmobile={staffDetails.mobile_no}
            corporateIDforTransfer={staffDetails.corporateId}
            corporateNameForTransfer={staffDetails.name}
            parentIDForTransfer={staffDetails.parentID}
            setIsStaffTransferClicked={setIsStaffTransferClicked}
          />
        )}

        {isResponse && (
          <Message
            type={isResponse.message ? isResponse.message : isResponse}
            message={
              isResponse.message
                ? `${staffDetails.name} has been successfully transferred to ${isResponse.data}`
                : `Staff ${staffDetails.name} disabled successfully`
            }
          />
        )}

        {/* Pagination */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            background: "white",
            zIndex: 1,
            border: "none",
            borderTop: "none",
          }}
        >
          <CommonTablePagination
            page={page}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            filteredData={data}
            styling={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
              border: "none",
              borderTop: "none",
              "& .MuiTablePagination-root": {
                border: "none",
                borderTop: "none",
              },
              "& .MuiTablePagination-toolbar": {
                border: "none",
                borderTop: "none",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default Records;
